/**
 * The estate's Employer Identification Number, the tax id the IRS issues it.
 *
 * Nine digits, written NN-NNNNNNN. Formatted as it is typed so the number on
 * screen matches the number on the IRS letter, and so every form that prints it
 * prints it the same way.
 */
export const formatEin = (value?: string | null): string => {
  const digits = (value || '').replace(/\D/g, '').slice(0, 9);

  return digits.length > 2 ? `${digits.slice(0, 2)}-${digits.slice(2)}` : digits;
};

/**
 * Validation for the EIN field. Empty passes: an estate applies for its EIN
 * after it is opened, so the field is blank for a while.
 */
export const EIN_RULE = {
  pattern: /^\d{2}-\d{7}$/,
  message: 'An EIN is nine digits, written as 12-3456789',
};
